/* API Roots */
import routes from "./routes";

let backendHost;
let mixpanelToken;
let stripeKey;

const MIXPANEL_TOKEN_DEV = '66dd8db9b39c2cb8be1b6db889b65080';
const MIXPANEL_TOKEN_PROD = '6b06e5fbaece8f891cf8b95363d590db';

const STRIPE_KEY_DEV = 'pk_test_hPiWGjJOCHjB0GynCBmnYDZL';
const STRIPE_KEY_PROD = 'pk_live_1eCDr7aBV6RLSOoTrcPuPZX8';

const hostname = window && window.location && window.location.hostname;

if (hostname === 'www.singleshift.sg' || hostname === 'singleshift.sg' || hostname === 'app.singleshift.sg') {
  // Production
  backendHost = 'https://server.singleshift.sg';
  mixpanelToken = MIXPANEL_TOKEN_PROD;
  stripeKey = STRIPE_KEY_PROD;
} else if (hostname === 'admin.singleshift.sg') {
  // Admin
  backendHost = 'https://server.singleshift.sg';
  mixpanelToken = MIXPANEL_TOKEN_DEV;
  stripeKey = STRIPE_KEY_DEV;
} else if (hostname === 'staging.singleshift.sg' || true) {
  // Staging
  backendHost = 'https://stagingserver.singleshift.sg';
  mixpanelToken = MIXPANEL_TOKEN_DEV;
  stripeKey = STRIPE_KEY_DEV;
} else {
  // Development
  backendHost = 'http://127.0.0.1:8000';
  mixpanelToken = MIXPANEL_TOKEN_DEV;
  stripeKey = STRIPE_KEY_DEV;
}

if (process.env.REACT_APP_BACKEND_HOST) {
  // Local overrides for the backendHost
  backendHost = process.env.REACT_APP_BACKEND_HOST;
}


export const API_ROOT = `${backendHost}/api/v1`;
export const AIRTABLE_HOOKS_ROOT = `${backendHost}/airtablehooks`;


// Insert any config stuff here

const config = {
  // TODO change this after refactoring backend to match new statuses
  statusColorMap: {
    'LOOKING_FOR_PROS': '#0074ff',
    'PROS_FOUND': '#28a745',
    'COMPLETED': '#28a745',
    'NO_PROS_FOUND': '#818389',
    'CANCELLED': '#818389',
  },
  status: {
    filled: {
      id: 'PROS_FOUND',
      label: 'Filled',
    }
  },
  routes: routes,
  ratePerShift: 10,
  apiRoot: `${backendHost}/api/v1`,
  airtableHooksRoot: `${backendHost}/airtablehooks`,
  mixpanelToken,
  stripeKey,
};

export default config;



// WEBPACK FOOTER //
// ./src/config.js